package com.essntl.core.quickbooks.data

import kotlinx.serialization.Serializable

@Serializable
data class QuickbooksDocNumberDto(
    val QueryResponse: QueryResponseDto,
) {
    @Serializable
    data class QueryResponseDto(
        val Invoice: List<InvoiceDto>,
    ) {
        @Serializable
        data class InvoiceDto(
            val DocNumber: String,
        )
    }
}